"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
Object.defineProperty(exports, "isCIC", {
  enumerable: true,
  get: function get() {
    return _mainConfig.isCICContentTree;
  }
});
exports.startAccountApp = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _reactAemVendorLibs = _interopRequireDefault(require("@eon-funke/react-aem-vendor-libs"));
var _ciamAccount = require("@eon-funke/ciam-account");
var _CallCenterUnauthorizedError = require("./cic/components/CallCenterUnauthorizedError/CallCenterUnauthorizedError");
var _RestHelper = _interopRequireDefault(require("./utils/RestHelper"));
var _Router = _interopRequireDefault(require("./utils/Router"));
var _CacheHandler = _interopRequireDefault(require("./utils/CacheHandler"));
var _GlobalErrorHandler = _interopRequireDefault(require("./utils/GlobalErrorHandler"));
var _SessionHandler = _interopRequireWildcard(require("./utils/SessionHandler"));
var _ActivityWatcher = _interopRequireWildcard(require("./utils/ActivityWatcher"));
var _SessionHandlerCic = _interopRequireDefault(require("./utils/SessionHandlerCic"));
var _declaration = _interopRequireDefault(require("./cic/redux/declaration"));
var _declaration2 = _interopRequireDefault(require("./csc/redux/declaration"));
var _mainConfig = _interopRequireWildcard(require("./mainConfig"));
var _EvngDomManipulator = _interopRequireDefault(require("./utils/EvngDomManipulator"));
var _MaintenanceHandler = _interopRequireDefault(require("./utils/MaintenanceHandler"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
// TODO what's the difference between this main.less and the one in indexAEM.js

(0, _MaintenanceHandler.default)();
var reducers;
if (_mainConfig.isCICContentTree) {
  reducers = _declaration.default;
} else {
  reducers = _declaration2.default;
}

// colors for development

if (_mainConfig.default.AEM_CONFIG.isAuthorMode || process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line no-console
  console.log('Are you wondering why you are not seeing your component being loaded? Check the readme section "React component startup troubleshooting"');
}
if (_mainConfig.default.AEM_CONFIG.siteVariable === 'EVNG') {
  _EvngDomManipulator.default.initDomManipulations();
}
var startAccountApp = exports.startAccountApp = function startAccountApp(routes) {
  var dkeComponents = routes.filter(function (route) {
    return (route === null || route === void 0 ? void 0 : route.routeName) === 'FlyoutMenu' || route.routeName === 'SearchAutocomplete';
  });
  (0, _ciamAccount.setSession)();
  _reactAemVendorLibs.default.startApp([].concat((0, _toConsumableArray2.default)(_ciamAccount.accountComponents), (0, _toConsumableArray2.default)(dkeComponents)), {
    accountData: _ciamAccount.accountData
  });
};
var startCicApp = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(routes) {
    var sharedComps, jwtParameter, promise;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _SessionHandler.default.setEngine(new _SessionHandlerCic.default());
            _SessionHandler.default.startSession();
            if (_SessionHandler.default.isUserLoggedIn(_SessionHandler.loginTypes.loggedIn)) {
              _ActivityWatcher.default.initActivityObserving(540, function () {
                var _sessionStorage;
                return ((_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage.mockMode) === '1' ? Promise.resolve() : _RestHelper.default.refreshCiamToken();
              }, function () {
                return _RestHelper.default.refreshMiddlewareToken();
              }, function () {
                var _CONFIG$AEM_CONFIG;
                return _SessionHandler.default.destroySession(true, _mainConfig.default === null || _mainConfig.default === void 0 ? void 0 : (_CONFIG$AEM_CONFIG = _mainConfig.default.AEM_CONFIG) === null || _CONFIG$AEM_CONFIG === void 0 ? void 0 : _CONFIG$AEM_CONFIG.autologoutLandingPage, null, '?logoutType=expired');
              });
            }
            if (_SessionHandler.default.isUserLoggedIn(_SessionHandler.loginTypes.callCenter)) {
              (0, _CallCenterUnauthorizedError.showCCUnauthorizedError)();
              _ActivityWatcher.default.initActivityObserving(540, function () {}, function () {
                return _RestHelper.default.refreshMiddlewareToken();
              }, function () {
                var _CONFIG$AEM_CONFIG2;
                return _SessionHandler.default.destroySession(true, _mainConfig.default === null || _mainConfig.default === void 0 ? void 0 : (_CONFIG$AEM_CONFIG2 = _mainConfig.default.AEM_CONFIG) === null || _CONFIG$AEM_CONFIG2 === void 0 ? void 0 : _CONFIG$AEM_CONFIG2.autologoutLandingPage, null, '?logoutType=expired');
              });
            }
            // adding mock service, if it is a holding site...
            if (_mainConfig.default.AEM_CONFIG.cscConfigAdded) {
              _context.next = 7;
              break;
            }
            _reactAemVendorLibs.default.startApp([{
              routeName: 'FlyoutMenu',
              load: function load(container, callback) {
                callback();
              }
            }], {});
            return _context.abrupt("return");
          case 7:
            sessionStorage.cscRedirectLock = '';
            sessionStorage.fallbackLoader = _mainConfig.default.AEM_CONFIG.fallbackGifLoader;
            _GlobalErrorHandler.default.errorPage500Path = _mainConfig.default.AEM_CONFIG.errorPageFor500;
            _GlobalErrorHandler.default.representativeInfoPage = _mainConfig.default.AEM_CONFIG.representativeInfoPage;
            _GlobalErrorHandler.default.redirectOn500 = _mainConfig.default.AEM_CONFIG.globalErrorFlag === 'true';
            _GlobalErrorHandler.default.addGlobalErrorMsgs(_mainConfig.default.AEM_CONFIG.globalErrorMessages);
            if (!(_mainConfig.default.AEM_CONFIG.isDkePage && !_SessionHandler.default.isUserLoggedIn(_SessionHandler.loginTypes.loggedIn))) {
              _context.next = 18;
              break;
            }
            sharedComps = [];
            routes.forEach(function (route) {
              if (route.routeName === 'FlyoutMenu') {
                sharedComps.push(route);
              }
            });
            _reactAemVendorLibs.default.startApp(sharedComps, {});
            return _context.abrupt("return");
          case 18:
            _RestHelper.default.initBaseURLs(sessionStorage.mockMode && sessionStorage.mockMode === '1' ? JSON.parse(sessionStorage.mockUrls) : _mainConfig.default.AEM_CONFIG.middlewareDomains);
            _RestHelper.default.addAxiosInterceptors();
            jwtParameter = _Router.default.getParameter('jwt');
            if (jwtParameter && !!_Router.default.getParameter('isCallCenterMode')) {
              _SessionHandler.default.destroySession(false);
              _CacheHandler.default.clearAllCache();
              _SessionHandler.default.initSession('Bearer', jwtParameter, _SessionHandler.loginTypes.callCenter);
              _ActivityWatcher.default.registerNewActivity();
              _ActivityWatcher.default.registerTokenRefreshing(_ActivityWatcher.tokenTypes.csc);
              _ActivityWatcher.default.initActivityObserving(540, function () {
                return function () {};
              }, function () {
                return _RestHelper.default.refreshMiddlewareToken();
              }, function () {
                var _CONFIG$AEM_CONFIG3;
                return _SessionHandler.default.destroySession(true, _mainConfig.default === null || _mainConfig.default === void 0 ? void 0 : (_CONFIG$AEM_CONFIG3 = _mainConfig.default.AEM_CONFIG) === null || _CONFIG$AEM_CONFIG3 === void 0 ? void 0 : _CONFIG$AEM_CONFIG3.autologoutLandingPage, null, '?logoutType=expired');
              });
              _reactAemVendorLibs.default.startApp(routes, reducers);
            } else if (_RestHelper.default.isCiamLogin()) {
              promise = _RestHelper.default.initCiamTokenExchange();
              promise.then(function () {
                _reactAemVendorLibs.default.startApp(routes, reducers);
              });
            } else {
              _reactAemVendorLibs.default.startApp(routes, reducers);
            }
          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function startCicApp(_x) {
    return _ref.apply(this, arguments);
  };
}();
var _default = exports.default = startCicApp;